import { Network } from "@aptos-labs/ts-sdk";
import { TappSDK } from "../core";
import { SDKConfig } from "../types";

interface InitTappSDKConfig {
  network?: Network.MAINNET | Network.TESTNET;
  url?: string;
}

const TESTNET_CONFIG: SDKConfig = {
  network: Network.TESTNET,
  contractAddress:
    "0x1ee4a76993d7610a69220684e12a036525f296635bfbd1c86935a523c919cc76",
  url: "https://api.testnet.tapp.exchange/v1",
};

const MAINNET_CONFIG: SDKConfig = {
  network: Network.MAINNET,
  contractAddress:
    "0x1ee4a76993d7610a69220684e12a036525f296635bfbd1c86935a523c919cc76",
  url: "https://api.testnet.tapp.exchange/v1",
};

export const initTappSDK = (initConfig: InitTappSDKConfig) => {
  const { network, url } = initConfig;
  const config = network == Network.MAINNET ? MAINNET_CONFIG : TESTNET_CONFIG;

  return new TappSDK({
    network: config.network,
    url: url ?? config.url,
    contractAddress: config.contractAddress,
  });
};
